module.exports = __webpack_public_path__ + "static/media/Sprchovy_olej_s_CBD_retina.66c9c937.png";